<template>
  <div class="columns is-vcentered">
    <div class="full-width border-top-1">
      <div class="card-header-title pd-0 pdl-50px hoverCardHeader striped-materiel
        columns is-marginless is-justify-content-space-between">
        <div class="column is-narrow ellipsis">
          <div class="columns is-vcentered">
            <div class="column is-4 is-cursor-pointer">
              <b-icon icon="subdirectory-arrow-right" class="mgt-5px">
              </b-icon>
            </div>
            <div class="column is-4">
              <qd-checkbox :value="materiel.selected"
                          v-if="afficherCheckboxMateriel"
                          :indeterminate="activateIndeterminate"
                          @input="setStateOfFace"
                          class="mgt-5px">
              </qd-checkbox>
            </div>
            <div class="column is-4 is-cursor-pointer"
                 :class="materiel.faces.length > 0 ? '' : 'disabled'"
                 @click="materiel.open = !materiel.open;">
              <b-icon :icon="materiel.open ? 'chevron-up' : 'chevron-down'" class="mgt-5px">
              </b-icon>
            </div>
          </div>
        </div>
        <div class="column is-3 ellipsis">
          <div class="columns">
            <div class="column is-narrow pdr-0 has-text-weight-bold">
              {{ $t('emplacementDispositifMaterielFacePicker.tab.materiel') }}
            </div>
            <div class="column is-7">
              <router-link-blank class="ellipsis"
                :to="{ name: 'c.gabed.emplacement-detailMateriel', params: {
              idMateriel: materiel.id, id: emplacementId }}"
                :message="materiel.code"/>
            </div>
          </div>
        </div>
        <div class="column is-1 has-text-default ellipsis">
          {{ getMaterielType(materiel.typeId) }}
        </div>
        <div class="column is-1 ellipsis has-text-default">
          {{ materiel.disposition }}
        </div>
        <div class="column is-1 ellipsis has-text-default ">
          {{ getMaterielFormat(materiel.formatId) }}
        </div>
        <div class="column is-1 ellipsis has-text-default">
          {{ materiel.numerique ? $t('emplacementDispositifMaterielFacePicker.tab.numerique')
          : $t('emplacementDispositifMaterielFacePicker.tab.nonNumerique') }}
        </div>
        <div class="column is-1 ellipsis has-text-default">
          {{ $t(getEtatMateriel(materiel.etat)) }}
        </div>
        <div class="column is-1 tooltipImageContent has-text-right" v-if="urlImage">
          <b-tooltip size="is-large" position="is-left" type="is-select">
            <b-icon icon="image-search-outline" class="is-cursor-pointer"/>
            <template v-slot:content>
              <img :src="urlImage" alt="">
            </template>
          </b-tooltip>
        </div>
        <div class="column is-1 has-text-right">
          <b-tag type="has-background-subMenu" class="has-text-white" v-if="!materiel.actif">
            {{$t('emplacementDispositifMaterielFacePicker.archive')}}
          </b-tag>
        </div>
      </div>
      <div class="card-content pd-10px" v-if="materiel.open">
        <ligne-face :face="face" :emplacementId="emplacementId"
                    @passToFalse="$emit('passToFalse', $event)"
                    @faceSelected="checkMaterielfMustBeSelectedOrNot()"
                    :affectations="getAffectation(face)"
                    :afficherAffectation="afficherAffectation"
                    :loaderFace="loaderFace"
                    :afficherCheckbox="afficherCheckboxFace"
                    :periode="periode"
                    :facesList="materiel.faces"
                    v-for="(face, index) in materiel.faces" :key="index"
                    :displayInactif="displayInactif"
                    v-show="displayInactif || face.actif">
        </ligne-face>
      </div>
    </div>
  </div>
</template>

<script>
import routerLinkBlank from '@/components/general/routerLinkBlank';
import ligneFace from '@/components/gabed/general/ligneFace';
import messageErreur from '@/services/general/messageErreur';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import getAll from '@/api/logistique/tourneeLigne';
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import loadAffectationOfFaces from '@/services/affectation/loadAffectation';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'ligneMateriel',
  components: {
    routerLinkBlank,
    ligneFace,
  },
  props: {
    emplacementId: {
      required: true,
      default: null,
      type: String,
    },
    materiel: {
      required: false,
      default: null,
      type: Object,
    },
    dateDebut: {
      required: true,
      type: Date,
      default: null,
    },
    dateFin: {
      required: true,
      type: Date,
      default: null,
    },
    urlImage: {
      required: false,
      type: String,
      default: null,
    },
    afficherCheckbox: {
      required: false,
      type: Boolean,
      default: true,
    },
    afficherCheckboxMateriel: {
      required: false,
      type: Boolean,
      default: true,
    },
    afficherCheckboxFace: {
      required: false,
      type: Boolean,
      default: true,
    },
    selectOnlyOneObject: {
      required: false,
      type: Boolean,
      default: false,
    },
    afficherAffectation: {
      required: false,
      type: Boolean,
      default: true,
    },
    displayInactif: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      affectations: [],
      loaderFace: false,
      periode: {
        dateDebut: this.dateDebut,
        dateFin: this.dateFin,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    activateIndeterminate() {
      let hasFaceSelected = this.materiel.faces.some((face) => { return face.selected; });
      if (this.materiel.faces.filter((face) => { return face.selected; }).length
        === this.materiel.faces.length) {
        hasFaceSelected = false;
      }
      return hasFaceSelected;
    },
    isLogistique() {
      return this.$route.name === 'l.logistique.tournee_modele-ajoutFace';
    },
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getMaterielType(typeId) {
      const materielTypeFind = this.parametre(PARAMETRES_KEYS.materielType)
        .find((type) => {
          return type.id === typeId;
        });
      return materielTypeFind ? materielTypeFind.libelle : '';
    },
    getMaterielFormat(formatId) {
      const materielFormatFind = this.parametre(PARAMETRES_KEYS.materielFormat)
        .find((format) => {
          return format.id === formatId;
        });
      return materielFormatFind ? materielFormatFind.libelle : '';
    },
    setStateOfFace(newStatus) {
      if (this.selectOnlyOneObject) this.$emit('passToFalse', this.materiel.id);
      this.materiel.faces.forEach((face) => {
        face.selected = this.selectOnlyOneObject ? false : newStatus;
      });
      this.materiel.selected = newStatus;
      this.$emit('materielSelected');
    },
    getAffectation(face) {
      if (!this.afficherAffectation) return [];
      let affectation = null;
      if (this.isLogistique) {
        affectation = this.affectations.find((affectation) => {
          return affectation.faceId === face.id;
        });
        affectation = affectation === undefined ? [] : [affectation];
      } else affectation = this.affectations[face.produitId];
      return affectation;
    },
    checkMaterielfMustBeSelectedOrNot() {
      if (!this.afficherCheckboxMateriel) return;
      this.materiel.selected = this.materiel.faces && this.materiel.faces.filter((face) => {
        return face.selected;
      }).length === this.materiel.faces.length && this.materiel.faces.length > 0;
      this.$emit('materielSelected');
    },
    getEtatMateriel(etat) {
      return ETAT_DISPOSITIF_PUBLICITAIRE.find((el) => {
        return el.value === etat;
      }).libelle;
    },
    loadAffectationLogistique(faces) {
      this.loaderFace = true;
      const params = {
        MaxResultCount: 9999,
        query: {
          faceIds: faces.map(face => face.id),
          societeId: this.societeActiveId,
        },
        skipCount: 0,
      };
      getAll(params).then((rslt) => {
        this.affectations = rslt.data.result.items;
        this.loaderFace = false;
      }).catch((e) => {
        messageErreur(this.$i18n);
        this.loaderFace = false;
        throw e;
      });
    },
    async loadAffectationOfFaces(faces, dateDebut, dateFin) {
      this.loaderFace = true;
      try {
        this.affectations = await loadAffectationOfFaces(faces, dateDebut, dateFin);
        this.loaderFace = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.loaderFace = false;
        throw e;
      }
    },
  },
  async mounted() {
    try {
      await this.loadParametres([PARAMETRES_KEYS.materielType,
        PARAMETRES_KEYS.materielFormat]);
      if (this.isLogistique && this.afficherAffectation) {
        this.loadAffectationLogistique(this.materiel.faces);
      } else if (this.afficherAffectation) {
        await this.loadAffectationOfFaces(this.materiel.faces, this.dateDebut, this.dateFin);
      }
    } catch (e) {
      messageErreur(this.$i18n);
    }
  },
};
</script>
